import { useMutation, useQuery } from '@apollo/client';

import GetMemberProperty from '../creators/GetMemberProperty.graphql';
import UpdateMemberProperty from '../creators/UpdateMemberProperty.graphql';

export const useMemberProperty = (propertyName, { onError = null } = {}) => {
  const { loading, error, data } = useQuery(GetMemberProperty, {
    variables: { name: propertyName },
    onError: err => onError && onError(err),
  });

  return {
    loading,
    error,
    value: data?.result?.value,
  };
};

export const useUpdateMemberProperty = (
  propertyName,
  { onCompleted = null, onError = null, refetchQueries }
) => {
  const [updateMemberProperty, { loading, error }] = useMutation(
    UpdateMemberProperty,
    {
      onCompleted: data => onCompleted && onCompleted(data),
      onError: err => onError && onError(err),
      refetchQueries,
      update: (cache, updatedData) => {
        cache.writeQuery({
          query: GetMemberProperty,
          variables: { name: propertyName },
          data: {
            result: updatedData?.data?.result?.property,
          },
        });
      },
    }
  );

  const boundUpdate = propertyValue => {
    updateMemberProperty({
      variables: {
        name: propertyName,
        value: propertyValue,
      },
    });
  };

  return {
    updateMemberProperty: boundUpdate,
    loading,
    error,
  };
};
